// Standalone /data-model page — the identity, provenance & marketplace methodology reference.
// Routed at the top level in index.js (same pattern as /data-dictionary), so it renders outside
// the campaign app shell. The content is the self-contained static doc in public/data-model.html;
// we embed it in a full-viewport iframe so its page-level styles stay fully isolated.
export default function DataModel() {
  return (
    <iframe
      title="Pollis — Person Data Model"
      src={`${process.env.PUBLIC_URL || ""}/data-model.html`}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
